"use client";

import React from "react";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { EcommerceProductsProvider, useEcommerceProducts } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
function ProductGrid() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
        {[...Array(8)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
            <div className="aspect-[4/5] w-full rounded-md bg-muted/30 animate-pulse" />
            <div className="h-5 w-2/3 bg-muted/30 rounded animate-pulse" />
            <div className="h-5 w-1/3 bg-muted/30 rounded animate-pulse" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12 text-muted-foreground font-sans">
        <p>Unable to load the marine categories at this time.</p>
      </div>;
  }
  if (!products || products.length === 0) {
    return <div className="text-center py-12 text-muted-foreground font-sans">
        <p>No marine parts found in this collection.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
      {products.map((product, i) => <div key={product.id} data-index={i} className="group relative flex flex-col">
          <div className="relative aspect-[4/5] w-full overflow-hidden rounded-md bg-white border border-secondary/30">
            {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-contain p-8 transition-transform duration-700 ease-out group-hover:scale-110" loading="lazy" /> : <div className="h-full w-full flex items-center justify-center text-muted-foreground font-mono text-xs uppercase tracking-widest">
                Technical Drawing Pending
              </div>}

            {}
            <div className="absolute inset-0 bg-primary/5 opacity-0 transition-opacity duration-300 group-hover:opacity-100 flex items-end justify-center pb-6 px-6">
              <Link to={product.link} className="w-full">
                <Button variant="secondary" className="w-full bg-primary text-primary-foreground hover:bg-primary/90 shadow-md font-default uppercase tracking-wider text-xs">
                  View Specifications
                </Button>
              </Link>
            </div>
          </div>

          <div className="mt-4 flex flex-col">
            <h3 className="text-lg font-mono font-bold text-primary uppercase tracking-tight">
              <Link to={product.link} className="hover:text-primary/80 transition-colors">
                {product.title}
              </Link>
            </h3>
            {product.price !== undefined && <p className="text-sm font-mono font-medium text-muted-foreground mt-1">
                OEM GRADE • REF: {product.id.toString().padStart(6, '0')}
              </p>}
          </div>
        </div>)}
    </div>;
}
export default function MarinePartCategories() {
  const wp_query_params = {
    per_page: 8
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="223647" id="marine-part-categories" className="py-24 bg-muted text-foreground">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16 text-center">
          <h2 className="text-4xl font-default font-bold text-primary uppercase tracking-tighter mb-4">
            Marine Part Categories
          </h2>
          <p className="text-muted-foreground font-default max-w-2xl mx-auto">
            Precision-engineered spare parts compatible with Yamaha outboards and other leading marine engines.
          </p>
        </div>
        <EcommerceProductsProvider wp_query={{
        per_page: 8
      }}>
          <ProductGrid />
        </EcommerceProductsProvider>
      </div>
    </section>;
}